import React, { useState, useEffect } from "react";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import InvoiceSpace from "./InvoiceSpace";
import editIcon from "../../assets/icons/editIcon.svg";
import bin from "../../assets/icons/Bin.svg";
import send from "../../assets/icons/send.svg";
import Pdf_icon from "../../assets/icons/Pdf icon.svg";
import blackDoller from "../../assets/icons/blackDoller.svg";
import CreditNote from "../../assets/icons/CreditNote.svg";
import FilterContacts from "../../assets/icons/FilterContacts.svg";
import { useLocation } from "react-router-dom";
import {
  FetchInvoices,
  AddInvoices,
  UpdateInvoice,
  setInvoiceStatusToFalse,
  InvoiceDelete,
  InvoiceGeneratePDF,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import InvoiceErrorPopup from "../../components/Dailogs/InvoiceErrorPopup";
import { useHistory, Link } from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/AddInvoice.css";
import TaskDelete from "../../components/Dailogs/TaskDelete";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import PrintPopup from "../Common/PrintPopup";
import html2pdf from "html2pdf.js";
import InvoicePDF from "../../assets/pdfs/InvoicePDF";

const AddInvoice = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const projectId = window.localStorage.getItem("projectid");
  const fetchInvoicesResponse = useSelector(
    (state) => state.user.fetchInvoicesResponse,
  );
  const addInvoicesResponse = useSelector(
    (state) => state.user.addInvoicesResponse,
  );
  const fetchInvoiceByIdResponse = useSelector(
    (state) => state.user.fetchInvoiceByIdResponse,
  );
  const updateInvoiceResponse = useSelector(
    (state) => state.user.updateInvoiceResponse,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const invoiceDeleteRes = useSelector((state) => state.user.invoiceDeleteRes);

  const [showPopup, setShowPopup] = useState(false);
  const [invoiceDelete, setInvoiceDelete] = useState("");
  const handleDelete = (e) => {
    dispatch(InvoiceDelete(invoiceDelete));
    setShowPopup(false);
  };

  const [invoiceList, setInvoiceList] = useState([]);
  const [addInvoiceList, setAddInvoiceList] = useState([]);
  const [invoice, setInvoice] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [date, setDate] = useState(moment(new Date()).format("DD.MM.YYYY"));
  const [id, setId] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [amount2, setAmount2] = useState("");
  const [VAT, setVAT] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pagesArray, setPagesArray] = useState([]);
  const [showError, setShowError] = useState(false);
  const [attachMessage, setAttachMessage] = useState("");
  const [listHover, setListHover] = useState(false);
  const [asc_invoiceID, setAsc_invoiceID] = useState("");
  const [hignlightInvoice, setHignlightInvoice] = useState(null);
  const [addNewPopupShow, setAddNewPopupShow] = useState(false);
  const [sendEmailShow, setSendEmailShow] = useState(false);
  const [email, setEmail] = useState("");

  const [filtersPopupShow, setFiltersPopupShow] = useState(false);
  const [allFilter, setAllFilter] = useState(true);
  const [sentFilter, setSentFilter] = useState(false);
  const [draftFilter, setDraftFilter] = useState(false);
  const [creditFilter, setCreditFilter] = useState(false);

  const [allStatus, setAllStatus] = useState("");
  const [draftStatus, setDraftStatus] = useState("");
  const [sentStatus, setSentStatus] = useState("");
  const [creditStatus, setCreditStatus] = useState("");
  const [invoicePDFData, setInvoicePDFData] = useState([]);

  const invoiceGenratePDFRes = useSelector(
    (state) => state.user.invoiceGenratePDFRes,
  );

  useEffect(() => {
    if (invoiceGenratePDFRes.status === true) {
      setInvoicePDFData(invoiceGenratePDFRes.data);
    }
  }, [invoiceGenratePDFRes]);

  useEffect(() => {
    // if (location?.pathname === "/updateProject") {
    if (location?.pathname.startsWith("/project/")) {
      let statusFilter = [
        "Draft",
        "Sent",
        "Not Sent",
        "Invoiced",
        "Not Invoiced",
        "Deleted",
        "Credited",
        "Credit",
      ];
      let statusFilter2 = [
        draftFilter ? "Draft" : "",
        sentFilter ? "Sent" : "",
        creditFilter ? "Credit" : "",
      ];

      if (allFilter) {
        dispatch(
          FetchInvoices(projectId, pageNumber, itemsPerPage, statusFilter),
        );
      } else {
        dispatch(
          FetchInvoices(projectId, pageNumber, itemsPerPage, statusFilter2),
        );
      }
    }
  }, [
    location,
    pageNumber,
    allFilter,
    sentFilter,
    draftFilter,
    creditFilter,
    invoiceDeleteRes,
  ]);

  useEffect(() => {
    if (fetchInvoicesResponse?.status === true) {
      setInvoiceList(fetchInvoicesResponse?.data);
      let pages = Math.ceil(fetchInvoicesResponse?.totalCount / itemsPerPage);
      setTotalPages(pages);
      setTotalItems(fetchInvoicesResponse?.totalCount);
      let array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      setPagesArray([...array]);
    }
  }, [fetchInvoicesResponse]);

  useEffect(() => {
    if (addInvoicesResponse?.status === true) {
      dispatch(FetchInvoices(projectId, pageNumber, itemsPerPage));
      setAddInvoiceList([]);
      setInvoice(false);
    }
  }, [addInvoicesResponse]);

  useEffect(() => {
    if (updateInvoiceResponse?.status === true) {
      dispatch(FetchInvoices(projectId, pageNumber, itemsPerPage));
      setAddInvoiceList([]);
      setInvoice(false);
      setIsUpdate(false);
      setUpdateId("");
      setId("");
      setDescription("");
      setAmount("");
      setVAT("");
      setDueDate("");
      dispatch(setInvoiceStatusToFalse());
    }
  }, [updateInvoiceResponse]);

  useEffect(() => {
    if (fetchInvoiceByIdResponse?.status === true) {
      setIsUpdate(true);
      setInvoice(true);
      setUpdateId(fetchInvoiceByIdResponse?.data[0]?.invoiceid);
      setId(fetchInvoiceByIdResponse?.data[0]?.invoicecode);
      setDescription(fetchInvoiceByIdResponse?.data[0]?.description);
      setVAT(fetchInvoiceByIdResponse?.data[0]?.vaTpercent);
      setAmount(fetchInvoiceByIdResponse?.data[0]?.totalExclusiveBtw);
      setDueDate(new Date(`${fetchInvoiceByIdResponse?.data[0]?.duedate}.00Z`));
    }
  }, [fetchInvoiceByIdResponse]);

  const addInvoice = () => {
    const totalinclusivebtw = +amount + +amount * (+VAT / 100);
    if (isUpdate) {
      return dispatch(
        UpdateInvoice(
          updateId,
          description,
          dueDate,
          amount,
          totalinclusivebtw,
          VAT,
        ),
      );
    }
    dispatch(AddInvoices(addInvoiceList));
  };

  const handleAdd = () => {
    if (!id) {
      setShowError(true);
      setAttachMessage("ID is required");
      return;
    }
    if (!description) {
      setShowError(true);
      setAttachMessage("Description is required");
      return;
    }
    if (!amount) {
      setShowError(true);
      setAttachMessage("Amount is required");
      return;
    }
    if (!VAT) {
      setShowError(true);
      setAttachMessage("VAT Percent is required");
      return;
    }
    if (!dueDate) {
      setShowError(true);
      setAttachMessage("Due Date is required");
      return;
    }
    const totalinclusivebtw = +amount + +amount * (+VAT / 100);
    setAddInvoiceList((list) => [
      ...list,
      {
        projectId,
        invoicecode: id,
        description,
        totalexclusivebtw: amount,
        totalinclusivebtw: totalinclusivebtw,
        vaTpercent: VAT,
        dueDate,
      },
    ]);
    setId("");
    setDescription("");
    setAmount("");
    setAmount2("");
    setVAT("");
    setDueDate("");
    setIsUpdate(false);
  };

  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (invoiceDeleteRes.status === true) {
    } else {
    }
  }, [invoiceDeleteRes]);

  const convertToPDF = (selectedName) => {
    if (invoiceGenratePDFRes.status === true) {
      const element = document.getElementById("teamPDFSection"); // pass id here of pdf div.
      if (element) {
        html2pdf()
          .from(element)
          .set({
            // filename: "asc.pdf",
            filename: `${selectedName}.pdf`,
            html2canvas: { scale: 5 }, // Scale factor for better quality not more than 9
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" }, // PDF options
          })
          .save();
        // .then(() => {
        //   toast.success(`${selectedName} Download complete`, {
        //     // autoClose: 3000,
        //     onOpen: playSuccessSound,
        //   });
        // });
      } else {
        console.error("Element not found for PDF conversion");
      }
    }
  };

  const handlePrintPopup = (item, printoption, templateid) => {
    let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
    // let selectedProject = localStorage.getItem("projectForPrint");
    let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
    // let selectedClientName = localStorage.getItem("clientNameForPrint");
    let selectedClientName = localStorage.getItem("clientname");

    let pdfTitle = `${selectedClientName}-Invoice ${
      item.invoicecode
    },-${workspaceName}-${moment(new Date()).format("YYYY.MM.DD, h:mm a")}`;

    if (printoption === "PRINT_USING_TEMPLATE") {
      dispatch(InvoiceGeneratePDF(item.invoiceid, templateid));
    }

    if (printoption === "CREATE_PDF") {
      dispatch(InvoiceGeneratePDF(item.invoiceid)).then(() => {
        // convertToPDF(item.clientname);
        convertToPDF(pdfTitle);
        console.log("asc33", item);
      });
    }
  };

  return (
    <>
      <InvoiceErrorPopup
        showError={showError}
        setShowError={setShowError}
        setAttachMessage={setAttachMessage}
        attachMessage={attachMessage}
      />

      {showPopup && (
        <TaskDelete
          animation={true}
          handleDelete={handleDelete}
          show={showPopup}
          onHide={() => setShowPopup(false)}
        />
      )}

      {!invoice ? (
        <div className="quotes-main-container" style={{ minHeight: "25rem" }}>
          <div className="quotes-div-1 fr" style={{ position: "relative" }}>
            <section
              className="fr w-50"
              style={{ gap: "7px", alignItems: "center", cursor: "pointer" }}
              onClick={() => setAddNewPopupShow(true)}
            >
              <img src={CardAddButton} className="addDocImg" alt="Add Icon" />
              <p className="addDocText">
                {/* Add Invoice */}
                {t("Add Invoice")}
              </p>
            </section>
            {/*ASC AddNew popup start */}
            <div
              className="addNewPopup_invo"
              style={{
                transform: addNewPopupShow ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
                position: "absolute",
              }}
            >
              <div className="d-flex pt-4 ps-5 gap-4">
                <p>
                  {/* Choose the type of document */}
                  {t("Choose the type of Document")}
                </p>
                <p
                  className="xCiecle pb-1 pointer"
                  onClick={() => {
                    setAddNewPopupShow(false);
                  }}
                >
                  x
                </p>
              </div>

              {/* <Link to="/NewInvoice" style={{ textDecoration: "none" }}> */}
              <div
                className="invoiceDiv m-auto mt-5 pointer"
                onClick={() => {
                  history.push("/NewInvoice", "from_project_invo");
                }}
              >
                <img className="InvoiceDoller" src={blackDoller} alt="" />
                <p className="mb-0">
                  {/* Invoice */}
                  {t("Invoice")}
                </p>
              </div>
              {/* </Link> */}

              <Link
                to={{
                  pathname: "/CreditNote",
                  state: { url: "/addProject", tab: "Invoice" },
                }}
                style={{ textDecoration: "none" }}
              >
                <div className="invoiceDiv m-auto mt-3 pointer">
                  <img className="InvoiceDoller" src={CreditNote} alt="" />
                  <p className="mb-0">
                    {/* Credit Note */}
                    {t("Credit Note")}
                  </p>
                </div>
              </Link>
            </div>
            {/*ASC AddNew popup end */}

            <div className="d-flex gap-2 filterTexts positionForFilterPopup">
              <p>
                {/* Filters */}
                {t("Filters")}
              </p>
              <img
                className="mb-1 pointer"
                src={FilterContacts}
                alt=""
                onClick={() => setFiltersPopupShow(true)}
              />
              <div className="d-flex gap-0">
                <p className="allBorder ps-1 pb-4">
                  {[
                    allFilter ? "All" : "",
                    draftFilter ? "Draft" : "",
                    sentFilter ? "Sent" : "",
                    creditFilter ? "Credit" : "",
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </p>
                {/* <p className="xIconInvoice px-1 pb-4">x</p> */}
              </div>

              {/*ASC filter popup start */}
              <div
                className="filterPopup_invo pt-3"
                style={{
                  transform: filtersPopupShow ? "scale(1)" : "scale(0)",
                  transitionDuration: "300ms",
                  top: "30px",
                  left: "-50px",
                }}
              >
                <h6
                  className="xCiecle ms-auto me-3 mt-1 pointer"
                  onClick={() => {
                    setFiltersPopupShow(false);
                  }}
                >
                  x
                </h6>

                <div class="form-check underTexts m-0">
                  <input
                    class="form-check-input pointer"
                    style={{
                      borderRadius: "50%",
                      width: "15px",
                      height: "15px",
                    }}
                    type="checkbox"
                    id="ascInvoice"
                    checked={allFilter}
                    onClick={() => {
                      setAllFilter(!allFilter);
                      setAllStatus("All");
                      setSentFilter(false);
                      setDraftFilter(false);
                      setCreditFilter(false);
                    }}
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    <p>
                      {/* All */}
                      {t("All")}
                    </p>
                  </label>
                </div>

                <div class="form-check underTexts m-0">
                  <input
                    class="form-check-input pointer"
                    style={{
                      borderRadius: "50%",
                      width: "15px",
                      height: "15px",
                    }}
                    type="checkbox"
                    id="ascInvoice"
                    checked={draftFilter}
                    onClick={() => {
                      setDraftFilter(!draftFilter);
                      setDraftStatus("Draft");
                      setAllFilter(false);
                    }}
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    <p>
                      {/* Draft */}
                      {t("Draft")}
                    </p>
                  </label>
                </div>

                <div class="form-check underTexts m-0">
                  <input
                    class="form-check-input pointer"
                    style={{
                      borderRadius: "50%",
                      width: "15px",
                      height: "15px",
                    }}
                    type="checkbox"
                    id="ascInvoice"
                    checked={sentFilter}
                    onClick={() => {
                      setSentFilter(!sentFilter);
                      setSentStatus("Sent");
                      setAllFilter(false);
                    }}
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    <p>
                      {/* Sent */}
                      {t("Sent")}
                    </p>
                  </label>
                </div>

                <div class="form-check underTexts m-0">
                  <input
                    class="form-check-input pointer"
                    style={{
                      borderRadius: "50%",
                      width: "15px",
                      height: "15px",
                    }}
                    type="checkbox"
                    id="ascInvoice"
                    checked={creditFilter}
                    onClick={() => {
                      setCreditFilter(!creditFilter);
                      setCreditStatus("Credit");
                      setAllFilter(false);
                    }}
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    <p>
                      {/* Credit */}
                      {t("Credit")}
                    </p>
                  </label>
                </div>

                <button
                  className="clearButton mt-3 mx-4 pb-5 pt-0"
                  onClick={() => {
                    setAllFilter(true);
                    setDraftFilter(false);
                    setSentFilter(false);
                    setCreditFilter(false);
                    setDraftStatus("");
                    setSentStatus("");
                    setCreditStatus("");
                  }}
                >
                  {/* Clear */}
                  {t("Clear")}
                </button>
              </div>
              {/*ASC filter popup end */}
            </div>

            <section
              className="fr quotes-div-sec-2 addinvoice-page-length addinvoice-pagelength-tablet"
              style={{ gap: "7px" }}
            >
              <p>
                {pageNumber === 1 ? 1 : itemsPerPage * (pageNumber - 1) + 1}-
                {itemsPerPage * pageNumber > totalItems
                  ? totalItems
                  : itemsPerPage * pageNumber}
              </p>
              <p>of</p>
              <p>{totalItems}</p>
              <p
                className="aro-lr"
                onClick={() => {
                  if (pageNumber === 1) return;
                  setPageNumber((p) => p - 1);
                }}
              >
                {"<"}
              </p>
              <p className="quote-current-page">{pageNumber}</p>
              <p
                className="aro-lr"
                onClick={() => {
                  if (pageNumber >= totalPages) return;
                  setPageNumber((p) => p + 1);
                }}
              >
                {">"}
              </p>
            </section>
          </div>

          <div
            className="invoice-main-grid_invo"
            style={{ borderBottom: "1px dashed #7E7E7E" }}
          >
            <p className="task-grid-element">
              {/* Invoice ID */}
              {t("Invoice ID")}
            </p>
            <p className="task-grid-element hide-on-mobile">
              {/* Date */}
              {t("Date")}
            </p>
            <p className="task-grid-element hide-on-mobile">
              {/* Description */}
              {t("Description")}
            </p>
            <p className="task-grid-element">
              {/* Due Date */}
              {t("Due Date")}
            </p>
            <p
              className="task-grid-element hide-on-mobile"
              style={{ textAlign: "end" }}
            >
              {/* Total <br /> excl. Btw */}
              {t("Total excl. Btw").slice(0, 5)}
              <br />
              {t("Total excl. Btw").slice(5)}
            </p>
            <p
              className="task-grid-element mobiletextend"
              style={{ textAlign: "end" }}
            >
              {/* Total <br /> incl. Btw */}
              {t("Total incl. Btw").slice(0, 5)}
              <br />
              {t("Total incl. Btw").slice(5)}
            </p>
          </div>

          {invoiceList.map((invoice, index) => {
            return (
              <div
                className={`invoice-main-grid_invo py-1 invoice-status-${invoice?.invoicestatus}`}
                key={index}
                style={{
                  borderBottom: "1px dashed #7E7E7E",
                  backgroundColor:
                    hignlightInvoice === invoice.invoiceid ? "#F1F1F1" : "",
                }}
              >
                <div
                  className="task-grid-element-2 pointer"
                  style={{
                    color:
                      invoice?.invoicestatus === "Draft"
                        ? "#95A7C6"
                        : ["Deleted", "Credited"].includes(
                              invoice?.invoicestatus,
                            )
                          ? "#333333"
                          : "",
                    fontWeight: invoice?.invoicestatus === "Draft" ? "700" : "",
                  }}
                  onMouseEnter={() => {
                    setListHover(true);
                    setAsc_invoiceID(invoice.invoiceid);
                    setHignlightInvoice(invoice?.creditInvoiceId);
                  }}
                  onMouseLeave={() => {
                    setListHover(false);
                    setAsc_invoiceID("");
                    setHignlightInvoice(null);
                  }}
                >
                  <div className="d-flex">
                    {/* <p>{invoice?.invoicecode}</p> */}
                    <p
                      className="invoiceCode"
                      style={{
                        opacity: ["Deleted", "Credited"].includes(
                          invoice?.invoicestatus,
                        )
                          ? "30%"
                          : "",
                      }}
                    >
                      {invoice?.invoicestatus === "Draft"
                        ? "DRAFT"
                        : invoice?.invoicecode}
                    </p>
                    {listHover && asc_invoiceID === invoice.invoiceid && (
                      <>
                        <div className="d-flex align-items-center ps-3 gap-3">
                          {invoice.invoicestatus === "Credited" ? (
                            <label className="lable-credited">
                              {invoice.invoicestatus}
                            </label>
                          ) : (
                            invoice.invoicestatus !== "Deleted" && (
                              <>
                                {invoice?.invoicestatus === "Draft" && (
                                  <img
                                    className="invoIcon"
                                    src={editIcon}
                                    alt=""
                                    onClick={() => {
                                      window.localStorage.setItem(
                                        "project_invoiceid",
                                        invoice?.invoiceid,
                                      );
                                      history.push("/UpdateInvoice");
                                    }}
                                  />
                                )}

                                {invoice?.invoicestatus !== "Draft" && (
                                  <div className="d-none">
                                    <img
                                      className="invoIcon"
                                      src={send}
                                      alt=""
                                      onClick={() => {
                                        setSendEmailShow(!sendEmailShow);
                                      }}
                                    />
                                    <PrintPopup
                                      type="Invoice"
                                      printData={invoiceGenratePDFRes}
                                      onRequestData={(
                                        selectedOption,
                                        selectedTemplate,
                                      ) =>
                                        handlePrintPopup(
                                          invoice,
                                          selectedOption,
                                          selectedTemplate,
                                        )
                                      }
                                    >
                                      <img
                                        className="invoIcon"
                                        src={Pdf_icon}
                                        alt=""
                                      />
                                    </PrintPopup>
                                  </div>
                                )}

                                <img
                                  className="invoIcon"
                                  src={bin}
                                  alt=""
                                  onClick={() => {
                                    setShowPopup(true);
                                    setInvoiceDelete(invoice.invoiceid);
                                  }}
                                />
                              </>
                            )
                          )}
                        </div>
                      </>
                    )}

                    <div
                      className="emailPopup_invo pt-3 ps-4"
                      style={{
                        transform: sendEmailShow ? "scale(1)" : "scale(0)",
                        transitionDuration: "300ms",
                        position: "absolute",
                      }}
                    >
                      <div>
                        <h6
                          className="xCiecle ms-auto me-5 mt-1 pointer"
                          onClick={() => {
                            setSendEmailShow(false);
                          }}
                        >
                          x
                        </h6>
                      </div>
                      <div className="asc-input-container ms-2" id="ascInput">
                        <label className="asc-label-top ClientNameText">
                          Email
                        </label>
                        <input
                          type="email"
                          className="asc_NormalInput_invo ps-4"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                      </div>
                      <button
                        className="button_invo mt-5 mx-auto"
                        onClick={() => {
                          setTimeout(() => {
                            setSendEmailShow(false);
                          }, 2000);
                        }}
                      >
                        <p>Send</p>
                      </button>
                    </div>
                  </div>
                </div>
                <p
                  className="task-grid-element-2 hide-on-mobile"
                  style={{
                    color:
                      invoice?.invoicestatus === "Draft"
                        ? "#95A7C6"
                        : invoice?.invoicestatus === "Deleted"
                          ? "#333333"
                          : "",
                    opacity: invoice?.invoicestatus === "Deleted" ? "30%" : "",
                  }}
                >
                  {moment(invoice?.createdat).format("DD.MM.YYYY")}
                </p>
                <p
                  className="task-grid-element-2 hide-on-mobile"
                  style={{
                    color:
                      invoice?.invoicestatus === "Draft"
                        ? "#95A7C6"
                        : invoice?.invoicestatus === "Deleted"
                          ? "#333333"
                          : "",
                    opacity: invoice?.invoicestatus === "Deleted" ? "30%" : "",
                  }}
                >
                  {invoice?.description}
                </p>
                <p
                  className="task-grid-element-2 hide-on-mobile"
                  style={{
                    color:
                      invoice?.invoicestatus === "Draft"
                        ? "#95A7C6"
                        : invoice?.invoicestatus === "Deleted"
                          ? "#333333"
                          : "",
                    opacity: invoice?.invoicestatus === "Deleted" ? "30%" : "",
                  }}
                >
                  {moment(invoice?.duedate).format("DD.MM.YYYY")}
                </p>
                <p
                  className="task-grid-element-2 text-end"
                  style={{
                    color:
                      invoice?.invoicestatus === "Draft"
                        ? "#95A7C6"
                        : invoice?.invoicestatus === "Deleted"
                          ? "#333333"
                          : "",
                    opacity: invoice?.invoicestatus === "Deleted" ? "30%" : "",
                  }}
                >
                  {europeanFormatWithSymbol(Number(invoice?.totalexclusivebtw))}
                </p>
                <p
                  className="task-grid-element-2 text-end"
                  style={{
                    color:
                      invoice?.invoicestatus === "Draft"
                        ? "#95A7C6"
                        : invoice?.invoicestatus === "Deleted"
                          ? "#333333"
                          : "",
                    opacity: invoice?.invoicestatus === "Deleted" ? "30%" : "",
                  }}
                >
                  {europeanFormatWithSymbol(Number(invoice?.totalinclusivebtw))}
                </p>
              </div>
            );
          })}
          {invoiceList.length === 0 && (
            <span className="noDataDisplay">
              {/* No data to display! */}
              {t("No data to display!\n")}
            </span>
          )}
        </div>
      ) : (
        <InvoiceSpace
          invoice={invoice}
          setInvoice={setInvoice}
          date={date}
          setDate={setDate}
          id={id}
          setId={setId}
          amount={amount}
          setAmount={setAmount}
          dueDate={dueDate}
          setDueDate={setDueDate}
          VAT={VAT}
          setVAT={setVAT}
          description={description}
          setDescription={setDescription}
          handleAdd={handleAdd}
          addInvoiceList={addInvoiceList}
          setAddInvoiceList={setAddInvoiceList}
          handleDelete={handleDelete}
          addInvoice={addInvoice}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          updateId={updateId}
          setUpdateId={setUpdateId}
          setInvoiceStatusToFalse={setInvoiceStatusToFalse}
          dispatch={dispatch}
          FetchTranslationList={FetchTranslationList}
        />
      )}
      {/* SEND PROPS DATA TO InvoicePDF for PDF */}
      <div className="d-none">
        <InvoicePDF
          invoicePDFData={[invoiceGenratePDFRes.data]}
          convertToPDF={convertToPDF}
        />
      </div>
    </>
  );
};

export default AddInvoice;
